import { ApiaUtil } from '@apia/components';
import { ReactNode } from 'react';

export const openFloatingChatController = ({
  children,
  onClose,
  title,
}: {
  children: ReactNode;
  onClose: () => void;
  title: string;
}) => {
  ApiaUtil.instance.modals.open({
    variant: 'layout.common.chat.assistant.floatingAssistant',
    defaultPosition: {
      bottom: '10px',
      right: '10px',
    },
    id: 'floatingAssistant',
    draggable: true,
    dragBounded: true,
    children: children,
    onClose,
    title,
  });
};
